import { ScreenResolutionManager } from "./Login/screenResolution";
import { IdentityProviderController } from "./Login/identityProviderController";
import { PasswordChangedController } from "./Login/passwordChangedController";
import { Verify2FATimerController } from "./Login/verify2FATimerController";

var screenResolutionManager = new ScreenResolutionManager();
var identityProviderController = new IdentityProviderController(localStorage);
var passwordChangedController = new PasswordChangedController();
var verify2FATimerController = new Verify2FATimerController();